<template>
    <div class="text-column">
        <h1 class="my-name">Thomas Perry</h1>
        <p class="some-description">+1 425 753 1991 | thomasgperry1999@gmail.com</p>
        <div class="links">
            <a class="github" target="_blank" href="https://github.com/tgperry">GitHub</a>
            <a class="itch" target="_blank" href="https://thomasgp.itch.io/">Indie Games</a>
            <a class="linkedin" target="_blank" href="https://www.linkedin.com/in/thomas-perry-csm/">LinkedIn</a>
        </div>
        
        <h1 class="about-title">About Me</h1>
        <p class="about">I currently work at Underdog Fantasy as a Ruby on Rails Software Engineer from my home office in the Greater Seattle area. My experience in jobs, education, and general life has consistently involved creativity, motivation, and high spirits. In my free time I 
work on personal web and mobile app projects, my culinary and espresso brewing skills, and getting outdoors whenever I can. Thank you for visiting my website, I hope it gives you a 
little better of an idea about myself! If you ever wish to contact me, please do not hesitate from using any of the methods above, I would be happy to hear from you to chat about anything.</p>     

        <h1 class="experience-title">Experience</h1>
        <p class="experience">It has been an incredible privilege to work for the following companies and collaborate with teams that have helped me grow into the person and professional I am today. I owe it to these coworkers in the same way I owe it to my teachers and professors for giving me the mentorship and guidance to grow and get better at what I love to do.</p>
        
        <h1 class="work-title"><a class="work-title-link" target="_blank" href="https://www.underdogfantasy.com/#">Underdog Fantasy</a> - Brooklyn, New York, US (Remote)</h1>
        <p class="job">Software Engineer - Ruby on Rails<br>June 2025 - Present</p>
        <p class="description">
            Underdog's mission is to make sports more fun and this is the outcome I've found while personally using the app and while helping to build it. I primarily work on the back-of-house tooling and wagering experience in my capacity as a Software Engineer at Underdog; seeking to create a seamless experience for both internal and external users in our shared goal of deriving more excitement from sports. If you have any questions about
            the Underdog app or my experience working here, please don't hesitate to reach out!
        </p>

        <h1 class="work-title"><a class="work-title-link" target="_blank" href="https://www.starbucks.com/">Starbucks</a> - Seattle, Washington, US</h1>
        <p class="job">Technical Product Manager<br>May 2024 - June 2025</p>
        <p class="description">
            As a Technical Product Manager (TPM) at Starbucks, my mission was to take an idea from the product team, work with design on a vision, and translate that design into technical requirements that myself and my engineering team could then bring to life. My time at Starbucks can be broken down into two distinct projects: the transformation of the Product API from REST into GraphQL and supporting the progress
            of the Digital Menu Board effort. I was initially brought aboard for the former, but once we got the project off the ground and into a maintenance state, I transferred over to the latter as it is one of the company's top technical objectives and investments. Leveraging GraphQL helped us synthesize a variety of different, but well organized microservices into a single API endpoint capable of delivering precise product data payloads
            based on the consumer's request. The Digital Menu Board project is an ongoing effort to transform print menus that you would see behind the counter of a Starbucks cafe into digital menus, capable of rendering dynamic content based on the desires of creative personnel.
        </p>

        <h1 class="work-title"><a class="work-title-link" target="_blank" href="https://www.credera.com/">Credera</a> - Seattle, Washington, US</h1>
        <p class="job">Senior Software Engineering Consultant<br>July 2022 - May 2024</p>
        <p class="description">
            The intersection of business and technology is where I find that I thrive and my work as a solutions consultant with Credera put me right in that sweet spot. My general responsibilities were to engage with business leaders and translate complex ideas into technical requirements that myself and a development team could turn into reality.
            My primary technical skills leveraged in this role were full stack development with expertise in API development (Spring, Java) and analytics implementations (Google Analytics), although the nature of the job required me to pick up new and diverse technologies quickly in order to meet the needs of the client. One of the most educational, challenging, and
            entertaining parts of the job was diving into how different companies ran their software teams and platforms. I believe the privilege of this experience helped me understand what "works" and what doesn't for companies with both large (public, millions of users) and small (internal, hundreds of users) software platforms.
        </p>
        <p class="job">Software Engineering Consultant<br>January 2021 - July 2022</p>
        <p class="description">
            I began with Credera as a Software Engineering Consultant and had the pleasure of working with a variety of fantastic clients and teammates in both the Denver office where I originally started and the Seattle office where I now call home.
        </p>

        <h1 class="work-title"><a class="work-title-link" target="_blank" href="https://agriculture.trimble.com/">Trimble, Inc.</a> - Westminster, Colorado, US (Remote)</h1>
        <p class="job">Software Engineering Intern (Agriculture Group, GNSS Group)<br>May 2020 - December 2020</p>
        <p class="description">
            I designed and developed the “Vehicle Sync” platform to support collaborative farming among operators in real time using Vue.js, HTML, CSS, Java. Vehicle Sync is a web application served using Android Webview, and I therefore got some experience working in the Android environment and specifically Android Studio. 
            I also developed a GNSS Logging tool to automate issue diagnostics related to in-field satellite disconnects. This project is very similar to what I did with PACCAR, however Trimble's technologies and data storage methods are proprietary, so I was working with reduced documentation. I believe this makes the project a very fun challenge.
        </p>

        <h1 class="work-title"><a class="work-title-link" target="_blank" href="https://cs.mines.edu/">Colorado School of Mines</a> - Golden, Colorado, US (Remote)</h1>
        <p class="job">CSCI261 Programming Concepts Tutor<br>August 2020 - December 2020</p>
        <p class="description">
            Tutored primarily Freshman and Sophomore students in the fundamentals and applications of C++.
        </p>

        <h1 class="work-title"><a class="work-title-link" target="_blank" href="https://www.sunlightx.com/">Sunlight Aerospace</a> - Boulder, Colorado, US</h1>
        <p class="job">Contract Software Engineer<br>August 2019 - December 2019</p>
        <p class="description">
            Developed a threat detection sensor to aid unmanned flight of autonomous HALE (High Altitude Long Endurance) drones designed to deliver telecommunications to people or teams in remote locations. 
            My team and I collaborated in an Agile environment to produce quality assured Python code (70% object recognition success in flight, 1 second heads up object prediction) based on the YOLO RCNN algorithm. The team I worked on performed
            Agile well (I know what you're thinking – I thought we actually did perform Agile fairly well) and employed Azure DevOps to ensure organization and simplicity.
        </p>

        <h1 class="work-title"><a class="work-title-link" target="_blank" href="https://www.paccar.com/">PACCAR</a> - Mt. Vernon, Washington, US</h1>
        <p class="job">Advanced Driver Assistance Systems Engineering Intern<br>June 2019 - August 2019</p>
        <p class="description">
            Developed a data mining tool for the autonomous commercial vehicle project using Python, C++, ROS. The tool was designed to extract moments of interest from a stream of data taken from an autonomous vehicle and generate an HTML report for those moments that included interactive plots supported by PlotJuggler and RViz. 
            While with PACCAR I was trained in automotive functional safety, ISO26262 protocol, and the CANdb++ of the Vector Automotive Software Suite.
        </p>

        <h1 class="education-title">Education</h1>
        <p class="education">Education is at the core of what makes me, me. I have had the distinct privilege of receiving some of the best education possible, from elementary school to my undergrad, and have been supported by the teachers I have met from every level the entire way.</p>
        <h1 class="school-title">Colorado School of Mines - Golden, Colorado, US</h1>
        <p class="graduating">B.S. Computer Science &amp; Data Science, Cum Laude<br>August 2017 - December 2020</p>
        <p class="classes">
            Here is a list of Computer Science classes I enjoyed while at the Colorado School of Mines:
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=CSCI370">Advanced Software Engineering</a> (Python)
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=CSCI406">Algorithms</a> (C++, Python)
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=CSCI341">Computer Organization</a> (C++, Python)
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=CSCI423">Computer Simulations</a> (Python)
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=CSCI303">Data Science</a> (Python)
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=CSCI403">Databases</a> (SQL, PostgreSQL)
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=CSCI262">Data Structures</a> (C++)
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=CSCI477">Game Development</a> (GML, C#)
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=MATH332">Linear Algebra</a>
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=CSCI274">Linux OS</a> (Vim)
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=CSCI470">Machine Learning</a> (Python)
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=CSCI261">Programming Concepts</a> (C++)
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=CSCI400">Programming Languages</a> (OCaml, JavaScript)
            <br><br>
            Here is a list of Computer Science classes I enjoyed while abroad in Oviedo, Spain: <br>
            (Links are to Mines equivalent courses)
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=CSCI358">Discrete Mathematics</a>
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=CSCI442">Operating Systems</a> (C)
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=CSCI306">Software Architecture</a> (TypeScript, HTML, CSS)
            <br><br>
            Here is a list of Statistics classes I have taken that relate to the Data Science industry:
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=MATH424">Applied Statistics</a>
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=MATH201">Introduction to Probability and Statistics</a>
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=MATH335">Mathematical Statistics</a>
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=MATH334">Probability</a>
            <br>-<a class="classes_link" target="_blank" href="https://catalog.mines.edu/search/?search=MATH438">Stochastic Models</a>
        </p>
        <h1 class="school-title">La Universidad de Oviedo - Oviedo, Asturias, ES</h1>
        <p class="graduating">Department of Mathematics and Computer Science 
            <br>January 2019 - May 2019
            <br><br>
            Aside from having an amazing time, gaining a deeper appreciation for the Spanish culture and language, traveling to places all over, and making lifelong friends, I had the incredible honor to collaborate with a group of very intelligent computer science students to develop a decentralized, person to person chat application using SOLID, a web technology under development by Sir Tim Berners-Lee. During that time, I even had the remarkable experience of communicating with Sir Berners-Lee over the SOLID chat room on Gitter. What an incredible experience to place the cherry on top of one of the best times of my life. I cannot wait to travel back to Asturias and see my friends there again.
        </p>

        <h1 class="school-title">Woodinville High School - Woodinville, Washington, US</h1>
        <p class="graduating">Graduated May 2017 GPA: 4.0 Unweighted
            <br>
            <br>Highlighted Accolades:
            <br>-Valedictorian
            <br>-AP Scholar with Distinction
            <br>-WHS Track and Field Team Captain, 2017
            <br>-DECA Competition International First Place, Sports Entertainment Marketing, Anaheim 2017
            <br>-DECA Competition International First Place, Buying and Merchandising, Nashville 2016
            <br>-Student Government, Freshman Class Representative       
        </p>
        <h1 class="design-title">Design Work</h1>
        <p class="design">Since I was a kid I have been very interested in design and art of all mediums. I have had the privilege of visiting art museums all over the world, always making a point to do so on my travels, but my favorite of all time 
            is in my hometown, the Seattle Art Museum. The second semester of my junior year at Mines, I was able to take part in a special topics class on the history of art and its relation to the environment. Taking that class further solidified my belief
            in the connection between art, environment, and computer science. The elegance and sentient nature of code exhibits a unique and interpretive beauty that I am personally enraptured in. But I digress, here are some logos that I have created as I explore my
            own abilities in the realm of artwork and design. All of these were done using the Adobe Creative Cloud suite. I also did a lot of the art for the indie games I have developed that are linked at the top of this screen, but I cannot take away credit from my
            incredible teammate and great friend who I worked with on those games and who led the way for a lot of the design, Tyler Zudans.  
        </p>

        <img class="design-work" src="../assets/DPIOpticsC2.png"/>
        <p class="design-description">A logo done for my dad's consulting business. Designing this with him was some of the most fun in front of a computer I have ever had – who knew your own dad would be your favorite client! And it was pro bono!</p>
        <img class="design-work" src="../assets/MMPLogo.png"/>
        <p class="design-description">A logo done for the painting company I worked for while in high school. I still love getting out and doing manual labor of all kinds, my favorite is mowing the lawn.</p>
        <img class="design-work-special" src="../assets/MOPGALogo.png"/>
        <p class="design-description">A logo done for an environmental resource conservation initiative I began after the US withdrew from the Paris Climate Agreement. MOPGA stands for Make Our Planet Great Again.</p>
        <img class="design-work-special" src="../assets/SAAVELogo.png"/>
        <p class="design-description">A logo done for Student Activists Against Violence and for Education, a student group I was a part of that raised awareness about sexual assault on campus.</p>
        <img class="design-work-special" src="../assets/Me.png"/>
        <p class="design-description">This is me in pixel art, haha!</p>

        <h1 class="projects-title">What Am I Working On Right Now?</h1>
        <p class="projects">Currently, I am holding a role at Starbucks as a Technical Product Manager and working on some side projects. Without giving away too much, my side projects include a website that serves video and audio content based on a user's preferences and a machine learning tool that transcribes lectures into
            organized notes. Stay tuned for the results of these projects, as they're sure to be linked here. Wish me luck and know that I'm wishing you the same in all of your endeavors! Here's a neat quote for your motivation:
        </p>
        <p class="quote">"If you view all of your problems as opportunities, eventually you'll run out of problems."</p>
        <h1 class="quotes-title">That's Thomas!</h1>
        <p class="quote-desc">Now that you've read through my site and learned all about me, it's time to test your new knowledge in a classic game of <i>That's Thomas!</i> Simply begin the game and choose "That's Thomas!" if you believe the statement about me is correct or "Wrong!" if you know it just isn't true. Good luck and have fun!
        </p>
        <div class="quotes">
            <true-false />
        </div>
        <p class="copyright">Copyright &copy; {{ new Date().getFullYear() }} Thomas Perry</p> 
    </div>
</template>

<script>
import TrueFalse from './TrueFalse.vue';

export default {
  name: 'Main-Page',
  methods: {
    
  },
  components: {
    TrueFalse
  }
}
</script>

<style scoped>
/* Responsive webpage - desktop*/
@media (min-width: 770px) {
    .text-column {
        padding-top: 20px;
        width: 35%;
        margin-right: auto;
        margin-left: auto;
        line-height: 1.5;
    }
}

/* Responsive webpage - iPad or less*/
@media (max-width: 769px) {
    .text-column {
        padding-top: 20px;
        width: 70%;
        margin-right: auto;
        margin-left: auto;
        line-height: 1.5;
    }
}

.my-name {
    text-align: center;
    font-size: 60px;
    margin-bottom: 5px;
}

.some-description {
    text-align: center;
    color: gray;
}

.links {
    margin-top: 10px;
    text-align: center;
}

.github {
    color: black;
}

.itch {
    color: black;
    margin-left: 10px;
}

.linkedin {
    color: black;
    margin-left: 10px;
}

.about-title, .education-title, .experience-title, .design-title, .projects-title, .quotes-title {
    font-size: 25px;
    padding-top: 30px;
    margin-block-start: 0.3em;
    margin-block-end: 0.3em;
}

.about, .education, .experience, .design, .projects, .quote-desc {
    color: gray;
    margin-top: 5px;
}

.school-title, .work-title {
    font-size: 18px;
    margin-bottom: 0px;
    padding-bottom: 0px;
    margin-block-start: 0.1em;
    margin-block-end: 0.1em;
}

.work-title-link {
    color: #06A4FF;
    text-decoration: none;
}

.graduating, .classes, .job, .description, .classes_link {
    padding: 0px;
    font-size: 13px;
}

.classes_link {
    color: #06A4FF;
    text-decoration: none;
}

.design-work {
    padding-top: 25px;
    width: 90%;
    display: block;
    margin: 0 auto;
    object-fit: contain;
}

.design-work-special {
    padding-top: 25px;
    width: 50%;
    display: block;
    margin: 0 auto;
    object-fit: contain;
}

.design-description {
    display: block;
    text-align: center;
    margin: auto;
    width: 80%;
    margin-top: 5%;
    font-size: 13px;
    color: gray;
}

.quote {
    color: gray;
    font-style: italic;
    text-align: center;
    width: 80%;
    padding-top: 10px;
    margin: 0 auto;
    font-size: 20px;
    font-weight: 500;
}

.quotes {
    padding-top: 10px;
    margin: 0 auto;
}

.copyright {
    padding-top: 25px;
    padding-bottom: 20px;
    color: gray;
    font-size: 12px;
    bottom: 5px;
}
</style>
